/**
 * HerramientasPanel — GEN-TL-001: «Herramientas». Una tarjeta por herramienta
 * del catálogo (nombre + una línea de qué hace); Motor n8n se ve como UNA
 * sola tarjeta (GEN-TL-004). Solo admin: el ítem lo proyecta el kernel y la
 * puerta real es GET /v1/herramientas (403 al no-admin).
 *
 * GEN-TL-002: pulsar una tarjeta abre su ficha (solo lectura), en el mismo
 * panel, con un botón «Volver» — mismo patrón que MiEquipoPanel/FichaAgente.
 */

import { useEffect, useState } from 'react'
import { listHerramientas } from '../api/client.js'
import FichaHerramienta from './FichaHerramienta.jsx'

export default function HerramientasPanel() {
  const [datos, setDatos] = useState(null)
  const [abierta, setAbierta] = useState(null)

  useEffect(() => {
    if (abierta) return undefined
    let vivo = true
    listHerramientas()
      .then(d => vivo && setDatos(d))
      .catch(() => vivo && setDatos({ error: 'No se han podido cargar las herramientas.' }))
    return () => { vivo = false }
  }, [abierta])

  if (abierta) return <FichaHerramienta herramientaId={abierta} onVolver={() => setAbierta(null)} />

  const herramientas = datos?.herramientas ?? []
  return (
    <section className="mec-visor">
      <h2>Herramientas</h2>
      {!datos && <p className="equipo-estado">Cargando…</p>}
      {datos?.error && <p className="equipo-estado" role="alert">{datos.error}</p>}
      {datos && !datos.error && herramientas.length === 0 && (
        <p className="equipo-estado">Todavía no hay herramientas en el catálogo.</p>
      )}
      <ul className="equipo-grid" aria-label="Herramientas de los agentes">
        {herramientas.map(h => (
          <li key={h.id} className="equipo-card">
            <button type="button" className="equipo-card__abrir" onClick={() => setAbierta(h.id)}>
              <span className="equipo-card__datos">
                <span className="equipo-card__nombre">{h.nombre}</span>
                <span className="equipo-card__depto">{h.descripcion}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  )
}
